/**
 * Normalizes text by removing Vietnamese accents/diacritics and converting to lowercase.
 */
export const normalizeSearchText = (str: string): string => {
  return str
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/đ/g, 'd')
    .replace(/Đ/g, 'd')
    .toLowerCase()
    .trim();
};

/**
 * Filter option helper for Ant Design Select supporting case-insensitive
 * and accent-insensitive (Vietnamese & English) search.
 */
export const filterSelectOption = (
  input: string,
  option?: { label?: any; children?: any }
): boolean => {
  if (!input) return true;
  const label = option?.label ?? option?.children ?? '';
  const labelStr = typeof label === 'string' ? label : String(label || '');
  if (!labelStr) return false;

  const lowerLabel = labelStr.toLowerCase();
  const lowerInput = input.toLowerCase().trim();

  if (lowerLabel.includes(lowerInput)) return true;
  return normalizeSearchText(labelStr).includes(normalizeSearchText(input));
};

/**
 * Sorts array of objects with `name` alphabetically, with Vietnamese collation support.
 */
export const sortByName = <T extends { name: string }>(items: T[]): T[] => {
  return [...items].sort((a, b) =>
    (a.name || '').localeCompare(b.name || '', 'vi', { sensitivity: 'base', numeric: true })
  );
};
